import { withErrorBoundary } from 'react-error-boundary';
import type { ContentfulPageModel } from 'autogen/swagger/all';
import { useResolvedContentfulPageLiveUpdates } from 'components/pages/Contentful/shared/resolveContentfulResponse';
import ContentfulPage from './ContentfulPage';
import GenericContentfulErrorPage from './GenericContentfulErrorPage';
import Preview from './Preview';
import RecursionPreviewPage from './RecursionPreviewPage';

export function Render({ model }: { model: ContentfulPageModel }) {
    const { isPreview } = model;
    const { resolvedData, hasRecursion } = useResolvedContentfulPageLiveUpdates(model);

    if (isPreview) {
        return (
            <Preview model={model}>
                {hasRecursion ? (
                    <RecursionPreviewPage />
                ) : (
                    <ContentfulPage model={resolvedData} isPreview={isPreview} />
                )}
            </Preview>
        );
    }

    if (hasRecursion) {
        return <GenericContentfulErrorPage />;
    }

    return <ContentfulPage model={resolvedData} />;
}

export default withErrorBoundary(Render, {
    fallback: <GenericContentfulErrorPage />,
    onError(error, info) {
        console.error(error, info);
    }
});
